import type { IntlMeta } from "@sinch/mfe-types";
import deDE from "../translations/de-DE.json";
import enUS from "../translations/en-US.json";
import esMX from "../translations/es-MX.json";
import itIT from "../translations/it-IT.json";
import ptBR from "../translations/pt-BR.json";
import type { Translations } from "./intl.types";

type Locale = IntlMeta["locale"];
export type Language =
  | "en"
  | "de"
  | "pt"
  | "es"
  | "it"
  | "en-US"
  | "pt-BR"
  | "de-DE"
  | "es-MX"
  | "it-IT";

const defaultLanguage = "en";
const defaultCountry = "US";

const withEnglishFallback = (other: Partial<Translations> = {}): Translations =>
  Object.assign({}, enUS, other);

export const langToTranslations = (Language: Language): Translations => {
  const map: Record<Language, Partial<Translations>> = {
    en: enUS,
    "en-US": enUS,
    de: deDE,
    "de-DE": deDE,
    pt: ptBR,
    "pt-BR": ptBR,
    es: esMX,
    "es-MX": esMX,
    it: itIT,
    "it-IT": itIT,
  };

  return withEnglishFallback(map[Language]);
};

export const getBrowserLang = (): Language => {
  const languageArray = navigator.language?.split("-");
  const lang = languageArray[0] ? languageArray[0] : "en";
  switch (lang) {
    case "de":
      return lang;
    case "pt":
      return lang;
    case "es":
      return lang;
    case "it":
      return lang;
    default:
      return "en";
  }
};

export const setWindowIntlMeta = (locale: Locale) => {
  const [language = defaultLanguage, country = defaultCountry] =
    locale.split("-");

  window.meta = {
    ...window.meta,
    intl: {
      locale,
      language,
      country,
    },
  };
};
